import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {DIALOG_APP_CONFIG} from '@aviary/injection-tokens/app-provided.tokens';
import {DialogAppConfig} from '@aviary/dialogs/base-dialog/base-dialog.types';

export function provideAviaryDialogAppConfig(dialogAppConfig: DialogAppConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: DIALOG_APP_CONFIG, useValue: dialogAppConfig}
  ]);
}
